import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Clients from "../../features/clients/index";
import AddBranchClient from "../../features/clients/components/AddBranchClient";
import ClientDetails from "../../features/clientDetails/index";
import Employees from "../../features/employees/index";
import EmployeeDetails from "../../features/employeeDetails/index";
import PatientsList from "../../features/patients/index";
import Assets from "../../features/assets/index";
import Patient from "../../features/patient/index";
import Profile from "../../features/user/Profile";
import Gaps from "../../features/gaps/index";
import Tasks from "../../features/tasks/index";
import Salary from "../../features/salary/index";
import Prospectuses from "../../features/prospectuses/index";
import Reports from "../../features/reports/index";
import Report from "../../features/report/index";
import Leads from "../../features/crm/leads/index";
import Lead from "../../features/crm/lead/index";
import Opportunities from "../../features/crm/opportunities";
import Opportunity from "../../features/crm/opportunity";
import Contacts from "../../features/crm/contacts";
import Contact from "../../features/crm/contact";
import Campaigns from "../../features/crm/campaigns";
import Campaign from "../../features/crm/campaign";
import Events from "../../features/crm/events";
import Ok2GoRevaha from "../../features/ok2Go/Ok2GoRevaha";
import Ok2GoBtl from "../../features/ok2Go/Ok2GoBtl";
import DayCenter from "../../features/dayCenter";
import OrdersImport from "../../features/ordersImport";

const Router = ({ defaultResource }) => {
  return (
    <Switch>
      <Route
        exact
        path={"/branches/:branchId/"}
        render={(props) => (
          <Redirect
            to={`/branches/${props.match.params.branchId}/${defaultResource}`}
          />
        )}
      />

      <Route exact path={"/branches/:branchId/clients"}>
        <Clients />
      </Route>
      <Route exact path={"/branches/:branchId/clients/add"}>
        <AddBranchClient />
      </Route>
      <Route exact path={"/branches/:branchId/clients/:id"}>
        <ClientDetails />
      </Route>
      <Route exact path={"/branches/:branchId/employees"}>
        <Employees />
      </Route>
      <Route exact path={"/branches/:branchId/employees/:id"}>
        <EmployeeDetails mode="edit" />
      </Route>
      <Route exact path={"/branches/:branchId/patients"}>
        <PatientsList />
      </Route>
      <Route exact path={"/branches/:branchId/patients/:id"}>
        <Patient mode="edit" />
      </Route>
      <Route exact path={"/branches/:branchId/gaps"}>
        <Gaps />
      </Route>
      <Route exact path={"/branches/:branchId/diaries_approval"}>
        <Gaps diariesApproval={true} />
      </Route>
      <Route exact path={"/branches/:branchId/tasks"}>
        <Tasks />
      </Route>
      <Route exact path={"/branches/:branchId/branch_salary"}>
        <Salary />
      </Route>
      <Route exact path={"/branches/:branchId/accounting"}>
        <Prospectuses />
      </Route>
      <Route exact path={"/branches/:branchId/profile"}>
        <Profile />
      </Route>
      <Route exact path={"/branches/:branchId/assets"}>
        <Assets fromMain={true} />
      </Route>
      <Route exact path={"/branches/:branchId/reports"}>
        <Reports />
      </Route>
      <Route exact path={"/branches/:branchId/reports/:id"}>
        <Report />
      </Route>
      <Route exact path={"/branches/:branchId/leads"}>
        <Leads />
      </Route>
      <Route exact path={"/branches/:branchId/leads/:id"}>
        <Lead />
      </Route>
      <Route exact path={"/branches/:branchId/crm_patients"}>
        <Opportunities />
      </Route>
      <Route exact path={"/branches/:branchId/crm_patients/:id"}>
        <Opportunity />
      </Route>
      <Route exact path={"/branches/:branchId/contacts"}>
        <Contacts />
      </Route>
      <Route exact path={"/branches/:branchId/contacts/:id"}>
        <Contact />
      </Route>
      <Route exact path={"/branches/:branchId/campaigns"}>
        <Campaigns />
      </Route>
      <Route exact path={"/branches/:branchId/campaigns/:id"}>
        <Campaign />
      </Route>
      <Route exact path={"/branches/:branchId/events_schedule"}>
        <Events />
      </Route>
      <Route exact path={"/branches/:branchId/ok2go_btl"}>
        <Ok2GoBtl />
      </Route>
      <Route exact path={"/branches/:branchId/ok2go_revaha"}>
        <Ok2GoRevaha />
      </Route>
      <Route exact path={"/branches/:branchId/day_center"}>
        <DayCenter />
      </Route>
      <Route exact path={"/branches/:branchId/order_import"}>
        <OrdersImport />
      </Route>
    </Switch>
  );
};

export default Router;
